import { PaymentModeType, SystemAppType } from '@/constants';
import MainContent from '@/layouts/MainContent';
import { Spin } from 'antd';
import { orderBy } from 'lodash';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import './styles.less';
import { CheckOutlined, MinusOutlined } from '@ant-design/icons';
import SubscriptionModal from './SubscriptionModal';
import { SoftwareComponentDto, PlanSubscriptionModel } from '@/__generated';
import { apiSdk } from '@/httpClient';
import { formatCurrency } from '@/helpers/format';

const PAGE_TITLE = 'subscriptionsPage_Title';

export default function SubscriptionsPage() {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState<boolean>(false);
  const [softwareCpns, setSoftwareCpns] = React.useState<SoftwareComponentDto[]>([]);
  const [subscriptionPlans, setSubscriptionPlans] = React.useState<PlanSubscriptionModel[]>([]);
  const [subscriptionPlanId, setSubscriptionPlanId] = React.useState<string>();
  const getData = () => {
    setLoading(true);
    Promise.all([
      apiSdk.SoftwareComponentService.getActiveSoftwareComponents({ availableApps: SystemAppType.ConektoTransport as any }),
      apiSdk.PlanService.getSubscriptionPlans({ app: SystemAppType.ConektoTransport as any }),
    ])
      .then(([softwareCpnsRes, subscriptionPlanRes]) => {
        setSoftwareCpns(orderBy(softwareCpnsRes, x => x.name));
        setSubscriptionPlans(orderBy(subscriptionPlanRes, x => x.sequenceNumber));
      })
      .finally(() => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    getData();
  }, []);
  return (
    <div style={{ backgroundColor: '#f8f8f8', paddingBottom: 20 }}>
      <MainContent title={t(PAGE_TITLE)} noBackgroundColor>
        <Helmet title={t(PAGE_TITLE)} />
        <div className="ant-layout-content-body">
          <Spin spinning={loading}>
            <div id="subscriptionsPage">
              <div className="plan-feature">
                <div className="header">{t('subscriptionsPage_PlanFeature')}</div>
                <div className="plan-cpn">{t('subscriptionsPage_Registers')}</div>
                <div className="plan-cpn">{t('subscriptionsPage_PaymentMethod')}</div>
                {softwareCpns.map(res => {
                  return (
                    <div className="plan-cpn" key={res.id}>
                      {res.name}
                    </div>
                  );
                })}
              </div>
              {subscriptionPlans.map(plan => {
                return (
                  <div className={`plan ${plan.isActive ? 'active' : ''}`} key={plan.id}>
                    <div className={`header`}>
                      <div className="active-text">{t('base.Active')}</div>
                      <div className="detail">
                        <div className="plan-name">{plan.planName}</div>
                        <div className="price">
                          {formatCurrency(plan.monthlyFee)}
                          <span className="price-per-month">{t('subscriptionsPage_PerMonth')}</span>
                        </div>
                      </div>

                      <div
                        className="learn-more"
                        onClick={() => {
                          setSubscriptionPlanId(plan.id);
                        }}
                      >
                        {t('subscriptionsPage_LearnMore')}
                      </div>
                    </div>
                    <div className="plan-cpn">{`${plan.noOfRegister} ${t('subscriptionsPage_Registers')}`}</div>
                    <div className="plan-cpn">{PaymentModeType.__getValue(plan.paymentMethodType)}</div>
                    {softwareCpns.map(res => {
                      const isActive = plan.components?.includes(res.name || '');
                      return (
                        <div className="plan-cpn" key={res.id}>
                          {isActive ? (
                            <CheckOutlined style={{ color: '#22c55e', fontSize: 18, fontWeight: 'bold' }} />
                          ) : (
                            <MinusOutlined style={{ color: '#9ca3af', fontSize: 18, fontWeight: 'bold' }} />
                          )}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </Spin>
        </div>
        {subscriptionPlanId ? (
          <SubscriptionModal
            planId={subscriptionPlanId}
            onClose={reload => {
              setSubscriptionPlanId(undefined);
              if (reload) {
                getData();
              }
            }}
          />
        ) : null}
      </MainContent>
    </div>
  );
}
